import dayjs from "dayjs";
import { useEffect, useState } from "react";
import "dayjs/locale/id";
import { SummaryOrderResponse } from "types/order-summary";

interface SummaryProps {
    summary: SummaryOrderResponse["data"];
}

const TimeHeader = ({ summary }: SummaryProps) => {
    const [currentTime, setCurrentTime] = useState(dayjs().locale("id"));

    useEffect(() => {
        const timer = setInterval(() => setCurrentTime(dayjs().locale("id")), 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="w-full flex items-center justify-between mb-6 flex-wrap gap-4">
            {/* 🕒 Kiri: Judul & Waktu */}
            <div className="flex flex-col">
                <h1 className="font-bold text-3xl text-gray-800 mb-1">Antrian Pesanan</h1>
                <p className="text-gray-500 text-sm">
                    {currentTime.format("dddd, DD MMMM YYYY - HH:mm:ss")} WITA
                </p>
            </div>

            {/* 📊 Kanan: Ringkasan */}
            <div className="flex gap-3 ml-auto">
                <div className="bg-gray-50 border border-gray-100 px-4 py-4 rounded-xl shadow-sm flex items-center gap-1">
                    <span className="text-gray-500 text-lg">B2C:</span>
                    <span className="font-semibold text-lg text-gray-800">{summary?.data?.total_orders ?? 0}</span>
                </div>
                <div className="bg-gray-50 border border-gray-100 px-4 py-4 rounded-xl shadow-sm flex items-center gap-1">
                    <span className="text-gray-500 text-lg">B2B:</span>
                    <span className="font-semibold text-lg text-gray-800">{summary?.data?.total_orders_b2b ?? 0}</span>
                </div>
                <div className="bg-green-50 border border-green-100 px-4 py-4 rounded-xl shadow-sm flex items-center gap-1">
                    <span className="text-gray-500 text-lg">Tepat Waktu:</span>
                    <span className="font-semibold text-lg text-green-600">{summary?.data?.on_time ?? 0}</span>
                </div>
                <div className="bg-yellow-50 border border-yellow-100 px-4 py-4 rounded-xl shadow-sm flex items-center gap-1">
                    <span className="text-gray-500 text-lg">Terlambat:</span>
                    <span className="font-semibold text-lg text-yellow-600">{summary?.data?.late ?? 0}</span>
                </div>
                <div className="bg-red-50 border border-red-100 px-4 py-4 rounded-xl shadow-sm flex items-center gap-1">
                    <span className="text-gray-500 text-lg">Dibatalkan:</span>
                    <span className="font-semibold text-lg text-red-600">{summary?.data?.cancelled ?? 0}</span>
                </div>
            </div>
        </div>
    );
};

export default TimeHeader;
